import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import { createComponent } from '../../services/components';
import { derivePropsFromObject } from '../../services/props';
export function createChildComponent(componentConfig, item, items) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    itemIndex = _ref.itemIndex;
  var children = componentConfig.children,
    propMap = componentConfig.propMap,
    component = componentConfig.component;
  var props = _objectSpread({
    children: _isNil(children) ? null : (children || []).map(function (child) {
      return createChildComponent(child, item, items, {
        itemIndex: itemIndex
      });
    })
  }, derivePropsFromObject(item, propMap, items, {
    itemIndex: itemIndex
  }));
  return createComponent(component, props);
}
export function multipleComponentIterator(_ref2) {
  var _ref2$iterator = _ref2.iterator,
    iterator = _ref2$iterator === void 0 ? [] : _ref2$iterator,
    _ref2$components = _ref2.components,
    components = _ref2$components === void 0 ? [] : _ref2$components,
    _ref2$limit = _ref2.limit,
    limit = _ref2$limit === void 0 ? null : _ref2$limit,
    _ref2$start = _ref2.start,
    start = _ref2$start === void 0 ? null : _ref2$start;
  if (_isEmpty(iterator)) {
    return null;
  }
  var finalIterator = iterator;
  if (start) {
    finalIterator = iterator.slice(start);
  }
  if (limit) {
    finalIterator = iterator.slice(0, limit);
  }
  var iteratedComponents = finalIterator.map(function (item, itemIndex) {
    return components.map(function (componentConfig) {
      return createChildComponent(componentConfig, item, iterator, {
        itemIndex: itemIndex
      });
    });
  });
  return iteratedComponents.reduce(function (acc, nextComponents) {
    return [].concat(_toConsumableArray(acc), _toConsumableArray(nextComponents));
  });
}